// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"a7d548a3","522":"f680cda2","545":"32783348","551":"a22a53b6","605":"dd6279ae","662":"c0af0fd1"}[chunkId] + ".chunk.js";
};